const initialState = {
  isRunning: false,
  completedCount: 0
};
export class AbstractScheduler {
  constructor() {
    this.tasks = [];
    this.state = initialState;
    this.onNextTaskCancel = null;
    this.onNextRunCancel = null;
  }
  enqueue(task) {
    this.tasks.push(task);
    const {
      isRunning,
      completedCount
    } = this.state;
    const hasRunBefore = completedCount > 0;
    if (!isRunning && hasRunBefore) {
      this.run();
    }
  }
  cancel() {
    this.tasks = [];
    if (this.onNextTaskCancel) {
      this.onNextTaskCancel();
    }
    if (this.onNextRunCancel) {
      this.onNextRunCancel();
    }
  }
  run() {
    if (this.tasks.length === 0) {
      this.state = Object.assign({}, this.state, {
        isRunning: false
      });
      return;
    }
    this.onNextTaskCancel = this.schedule(() => {
      this.state = Object.assign({}, this.state, {
        isRunning: true
      });
      const task = this.tasks.shift();
      if (!task) {
        this.state = Object.assign({}, this.state, {
          isRunning: false
        });
        return;
      }
      task();
      this.state = Object.assign({}, this.state, {
        completedCount: this.state.completedCount + 1
      });

      // Defer the next run to the next tick of the event loop.
      const timerId = setTimeout(() => this.run(), 0);
      this.onNextRunCancel = () => clearTimeout(timerId);
    });
  }
}